module.exports = __webpack_public_path__ + "static/media/logo.30b84cf3.svg";